import React from "react";
import { motion } from "framer-motion";
import { BuildRounded } from "@mui/icons-material";
import { ACEcolors } from "@ace/ace-ui-web";
import { ReactComponent as AceLogo } from '../../assets/Ace_Hardware_Logo.svg';
import styles from "./authHeader.module.css";

// Shared tagline constant using Unicode escape to avoid encoding issues
export const AUTH_HEADER_TAGLINE = `Pickup \u2022 Swap \u2022 VTO`;

interface AuthHeaderProps {
    title?: string;
    className?: string;
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ title, className }) => (
    <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={className || styles.header}
    >
        <div className={styles.logoContainer}>
            <AceLogo style={{ width: "100%", height: "100%" }} />
        </div>
        <div className={styles.headerBackground}>
            <BuildRounded fontSize="small" sx={{ transform: 'scaleX(-1)', color: ACEcolors.primary.default }} />
            <p className={styles.header2}>
                {AUTH_HEADER_TAGLINE}
            </p>
        </div>
        {title && (
            <h1 className={styles.title}>
                {title}
            </h1>
        )}
    </motion.div>
);

export default AuthHeader;